<template>
  <print-preview @reset="reset" :landscape="landscape">
    <div slot="pages">
      <template>
        <page :style-object="styleObject">
          <template slot="header">
            <th :colspan="headers.length + 1">
              <div class="text-xs-center">
                <div class="flexRow px-2 pb-2">
                  <div class="flex-column" style="flex:1">
                    <img
                      alt="alt"
                      class="mb-2"
                      style="width:3cm;height:1cm"
                      src="@/assets/images/logo.svg"
                    />
                    <h2 class="xs12 primary--text font-weight-bold body-2">
                      انستیتوت جامعه مدنی افغانستان
                    </h2>
                    <h2 class="xs12 primary--text font-weight-bold body-2">
                      د افغانستان د مدنی ټولنو انسټیټیوټ
                    </h2>
                    <h2 class="xs12 primary--text font-weight-bold body-2">
                      Afghanistan Institute for Civil Society
                    </h2>
                  </div>
                </div>
                <v-divider class="flexRow" />
                <div class="flex-row py-2 text-xs-center">
                  {{ tableData.title }}
                </div>
              </div>
            </th>

            <tr class="pb-2">
              <td>{{ this.$t("number") }}</td>
              <td v-for="(item, i) in headers" :key="'c_' + i">
                <span>{{ item.text }}</span>
              </td>
            </tr>
          </template>
          <template slot="body">
            <tr v-for="(item, index) in items" :key="'a_' + index">
              <td v-if="showIndex">{{ index + 1 }}</td>
              <td v-else>{{ item.index }}</td>
              <td
                :key="'d_' + c"
                :class="item.class"
                v-for="(column, c) in headers"
              >
                <span>{{ getObjectValueByPath(item, column) }}</span>
              </td>
            </tr>
          </template>
          <div slot="footer" v-html="footer"></div>
        </page>
      </template>
    </div>
  </print-preview>
</template>
<script>
import { mapGetters } from "vuex";
import get from "lodash/get";

export default {
  computed: {
    ...mapGetters("ReportsModule", { tableData: "tableData" }),

    items() {
      return this.tableData.items;
    },

    headers() {
      return this.tableData.headers;
    },

    landscape() {
      return this.tableData.landscape;
    },

    footer() {
      return this.tableData.footer;
    },

    showIndex() {
      return this.tableData.index || true;
    },

    styleObject() {
      if (this.landscape) return { "min-height": "200mm", width: "290mm" };
      return { "min-height": "290mm", width: "200mm" };
    }
  },

  methods: {
    getObjectValueByPath(obj, filed) {
      if (filed.computed) return filed.computed(obj);
      let value = get(obj, filed.value, "");
      if (filed.filter) return filed.filter(obj);
      return value;
    },

    reset() {
      this.$store.commit("ReportsModule/setTableData", {
        title: "",
        items: [],
        headers: []
      });
      this.$router.back();
    }
  }
};
</script>
<style>
.flexFifty {
  width: 50%;
  display: flex;
}

.flexRow {
  display: flex;
  justify-content: space-between;
}

.address-box {
  border-radius: 25px;
  /* background: #343a40; */
  /* color: white; */
}
</style>
